module.exports = "/_next/static/images/investujeme-933929b363b853f468b97f8902dd8aa7.png";